<template>
  <div class="screen-discuss" :class="{'filter-blur':activitymoadal==true}">
    <vue-waterfall-easy
      :imgsArr="imgsArrNew"
      :anonymous="discussType"
      @scrollReachBottom="fetchImgsData"
      @enlargeBox="largeBox"
    ></vue-waterfall-easy>
    <div class="discuss-modal" v-show="showDiscussModal">
      <div class="modal-wraper" v-scrollBar>
        <div class="top">
          <img :src="getImg(discussData.headImage)" alt />
          <span class="name" :title='discussType==0 ? discussData.userName : $t("discuss.anonymous")'>{{ discussType==0 ? discussData.userName : $t("discuss.anonymous") }}</span>
          <div class="right">
            <span class="iconfont icon-dianzan"></span>
            <span class="num">{{ $t("discuss.goodNum", { num: discussData.praise }) }}</span>
          </div>
        </div>
        <div class="middle">
          <p v-html="discussData.message" ref="discuss-text"></p>
          <div class="img" v-if="discussData.location!=''">
            <img :src="discussData.location" alt ref="data-img" />
            <span class="iconfont icon-fangda fangda" ref="fangda" @click="largeImg"></span>
          </div>
        </div>
        <span class="iconfont icon-guanbi close" @click="closeDiscussModal"></span>
      </div>
    </div>
    <div
      class="img-modal"
      v-show="showImgModal"
      @click="closeImgModal"
      v-if="discussData.location!=''"
    >
      <div class="img">
        <img :src="discussData.location" alt />
        <span class="iconfont icon-guanbi img-close"></span>
      </div>
    </div>
    <div class="no-discuss" v-if="imgsArr.length==0">{{ $t("discuss.noAnswer") }}</div>
  </div>
</template>

<script>
import vueWaterfallEasy from "../vueWaterFallEasy/vueWaterFallEasy.vue";
import EventHandler from "../../common/js/EventHandler";
export default {
  name: "discuss",
  props: { activitymoadal: Boolean },
  data() {
    return {
      imgsArr: [],
      imgsArrNew: [],
      showImgModal: false,
      timer: null,
      showDiscussModal: false,
      discussData: [],
      discussType: 1, //0 实名 1 匿名
      orderType: 2, //默认时间倒叙
      classID: 0, //默认全部
      selectSort: false
    };
  },
  methods: {
    initPage() {
      let self = this;
      self.userId = self.common.getCookie("userId");
      self.activityId = self.common.getCookie("activityId");
      self.ocID = self.common.getCookie("ocId");
      self.fontPageNum = 1;
      self.fontPageSize = 20;
      self.pageSize = 999;
      self.getDetail();
      self.timer = setInterval(() => {
        self.getDetail();
      }, 2000);
    },
    initImgsArr() {
      let arr = [];
      let maxSize = this.fontPageSize * this.fontPageNum;
      arr = this.allPost;
      if (arr.length > maxSize) {
        arr.splice(maxSize);
      }
      return arr;
    },
    getDetail() {
      let self = this;
      let params = {
        discussionID: self.activityId,
        userID: self.userId,
        ocID: self.ocID,
        classID: self.classID,
        orderType: self.orderType
      };
      self.$http
        .get(self.baseURL1 + "/discussion/getDiscussionDetail", {
          params: params
        })
        .then(res => {
          let data = res.data;
          data.discussion.status = data.status;
          self.discussType = data.discussion.discussType;
          self.$emit("pushDetial", data.discussion);
          if (res.data.status == 3) {
            clearInterval(self.timer);
            self.timer = null;
          }
        });
      let replayListParams = params;
      replayListParams.ocID = null;
      replayListParams.pageSize = self.pageSize;
      replayListParams.pageNum = 1;
      self.$http
        .get(self.baseURL1 + "/discussion/getDiscussionFirstReplay", {
          params: replayListParams
        })
        .then(res => {
          let data = res.data;
          self.allPost = data.list || [];
          self.pageSize = data.count;
          self.imgsArr = self.initImgsArr();
        });
    },
    fetchImgsData() {
      let totalPageNum =
        this.pageSize % this.fontPageSize == 0
          ? this.pageSize / this.fontPageSize
          : parseInt(this.pageSize / this.fontPageSize) + 1;
      if (this.fontPageNum < totalPageNum) {
        this.fontPageNum++;
      }
      this.imgsArr = this.initImgsArr();
    },
    largeBox(data) {
      this.provisionalClear(true);
      this.discussData = data;
      this.showDiscussModal = true;
      if (data.location && data.location != "") {
        this.$nextTick(() => {
          var imgResources = this.$refs["data-img"];
          var fangda = this.$refs["fangda"];
          var imgObj = new Image();
          imgObj.src = imgResources.src;
          var posLeft = imgResources.clientWidth;
          var posTop = imgResources.clientHeight;
          if (posLeft < 365) {
            fangda.style.top = posTop - 35 + "px";
            fangda.style.left = posLeft - 35 + "px";
          }
          if (posLeft == 365 && posTop < 275) {
            fangda.style.left = 330 + "px";
            fangda.style.top = posTop - 35 + "px";
          }
          if (posLeft < 365 && posTop == 275) {
            fangda.style.top = 240 + "px";
            fangda.style.left = posLeft - 35 + "px";
          }
        });
      }
      this.$nextTick(() => {
        console.log(
          $(this.$refs["discuss-text"])
            .find("a")
            .attr("href", "javascript:void(0)")
        );
      });
    },
    largeImg: function() {
      this.showImgModal = true;
    },
    closeImgModal: function() {
      this.showImgModal = false;
    },
    closeDiscussModal() {
      this.showDiscussModal = false;
      this.provisionalClear(false);
    },
    provisionalClear(isClear) {
      let self = this;
      if (isClear) {
        clearInterval(self.timer);
        self.timer = null;
      } else {
        self.timer = setInterval(() => {
          self.getDetail();
        }, 2000);
      }
    },
    getImg(imgUrl) {
      return this.common.handleImg(imgUrl, this.rescourceURL, this.discussType);
    },
    discussPicOperation(param) {
      if (param == 0) {
        this.closeImgModal();
      } else {
        this.largeImg();
      }
    },
    largeDiscussDetial(param) {
      if (param == 0) {
        this.closeDiscussModal();
      } else {
        this.largeBox(param);
      }
    },
    changeSort(param) {
      this.orderType = param.orderBy;
      this.classID = param.classId;
      this.selectSort = true;
    }
  },
  mounted: function() {},
  created() {
    this.initPage();
    EventHandler.bindEvent("discussPicOperation", this.discussPicOperation);
    EventHandler.bindEvent("largeDiscussDetial", this.largeDiscussDetial);
    EventHandler.bindEvent("changeSort", this.changeSort);
  },
  components: { vueWaterfallEasy },
  watch: {
    $route: "initPage",
    imgsArr(newVal, oldVal) {
      if (newVal.length >= oldVal.length) {
        if (oldVal.length == 0 || this.selectSort) {
          this.imgsArrNew = this.imgsArr;
        } else {
          for (var i = 0; i < newVal.length; i++) {
            var count = 0;
            for (var j = 0; j < this.imgsArrNew.length; j++) {
              if (
                this.imgsArrNew[j].postID == newVal[i].postID &&
                this.imgsArrNew[j].praise == newVal[i].praise
              ) {
                count++;
                break;
              }
              if (
                this.imgsArrNew[j].praise != newVal[i].praise &&
                this.imgsArrNew[j].postID == newVal[i].postID
              ) {
                this.imgsArrNew.splice(i, 1, newVal[i]);
                count++;
                break;
              }
            }
            if (count == 0) {
              this.imgsArrNew.splice(i, 0, newVal[i]);
            }
          }
        }
      }
      if (newVal.length < oldVal.length) {
        for (var i = 0; i < this.imgsArrNew.length; i++) {
          var count = 0;
          for (j = 0; j < newVal.length; j++) {
            if (newVal[j].postID == this.imgsArrNew[i].postID) {
              count++;
              break;
            }
          }
          if (count == 0) {
            this.imgsArrNew.splice(i, 1);
          }
        }
      }
      console.log(this.imgsArrNew);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "discuss.scss";
</style>



// WEBPACK FOOTER //
// src/components/discuss/discuss.vue